import { makeStyles } from "@material-ui/core";


export const useStyles = makeStyles((theme) => ({
    close: {
        position: "absolute",
        top: 8,
        right: 8,
        color: theme.palette.primary.contrastText,
    },
    divider: {
        backgroundColor: theme.palette.primary.light,
    },
    menu: {
        backgroundColor: theme.palette.primary.dark,
        color: theme.palette.primary.contrastText,
        borderRadius: 8,
    },
    popper: {
        zIndex: theme.zIndex.modal,
        marginBottom: 16,
        width: 300,
        marginRight: "0.625rem",
    },
    settingsLink: {
        "&:hover": {
            backgroundColor: theme.palette.primary.light,
        },
    },
}));
